export const getAccessStatus = (state) => state.status